import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationFacade, OpenTripPlannerFacade } from '@ridango/components';
import { BannersFacade } from '@ridango/components/lib/banners';
import { FavoriteStop, JourneyPlannerFacade } from '@ridango/components/lib/journey-planner';
import { AuthService, BaseComponent } from '@ridango/core';
import Env from '@ridango/core/env';
import { map, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'gl-journey-planner-search',
    templateUrl: './journey-planner-search.component.html',
    styleUrls: ['./journey-planner-search.component.scss']
})
export class JourneyPlannerSearchComponent extends BaseComponent implements OnInit, OnDestroy {
    assetsPath$ = this.applicationFacade.assetsPath$;
    searchRecentlyJourneys$ = this.openTripPlannerFacade.searchRecentlyJourneys$;
    favoriteStops$ = this.journeyPlannerFacade.favoriteStops$;
    banners$ = this.bannersFacade.banners$.pipe(map((banners) => banners.slice(0, 3)));

    public languageCode: string;

    constructor(
        @Inject('ENV') public env: Env,
        private applicationFacade: ApplicationFacade,
        private bannersFacade: BannersFacade,
        private journeyPlannerFacade: JourneyPlannerFacade,
        private router: Router,
        private authService: AuthService,
        public translate: TranslateService,
        private openTripPlannerFacade: OpenTripPlannerFacade
    ) {
        super();
    }

    ngOnInit(): void {
        this.languageCode = this.translate.currentLang;
        this.translate.onLangChange.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => {
            this.languageCode = this.translate.currentLang;
        });

        if (this.env.JOURNEY_PLANNER?.SHOW_FAVORITES) {
            this.journeyPlannerFacade.getFavoriteStops();
        }

        if (this.env.SHOW_BANNERS) {
            this.bannersFacade.getBanners();

            this.translate.onLangChange.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => {
                this.bannersFacade.getBanners();
            });
        }
    }

    public async handleClickOnLocation(location: FavoriteStop): Promise<void> {
        await this.router.navigate([this.translate.currentLang, 'journey-planner', 'result'], {
            state: { data: location }
        });
    }
}
